module.exports = __webpack_public_path__ + "static/img/7.14ae80fa.png";